import { resolveUpdate } from './resolve';

export const createAbsencesSlice = (set) => ({
  userAbsences: [],
  setUserAbsences: (suivant) =>
    set((etat) => ({ userAbsences: resolveUpdate(suivant, etat.userAbsences) })),
  absencesByDev: {}, // acceptées seulement — bloque la capacité (timeline, affectations)
  setAbsencesByDev: (suivant) =>
    set((etat) => ({ absencesByDev: resolveUpdate(suivant, etat.absencesByDev) })),
  absencesByDevAll: {}, // toutes (attente/acceptée/refusée) — affichage Équipe uniquement
  setAbsencesByDevAll: (suivant) =>
    set((etat) => ({ absencesByDevAll: resolveUpdate(suivant, etat.absencesByDevAll) })),
  leaveMovements: [], // journal du solde CP (leave_balance_movements), filtré par la RLS
  setLeaveMovements: (suivant) =>
    set((etat) => ({ leaveMovements: resolveUpdate(suivant, etat.leaveMovements) })),
  leaveBalanceEditDevId: null, // devId en cours d'édition du solde CP
  setLeaveBalanceEditDevId: (suivant) =>
    set((etat) => ({ leaveBalanceEditDevId: resolveUpdate(suivant, etat.leaveBalanceEditDevId) })),
  teamTab: 'demandes', // onglet actif de la page Équipe (manager)
  setTeamTab: (suivant) => set((etat) => ({ teamTab: resolveUpdate(suivant, etat.teamTab) })),
  myLeaveTab: 'demandes', // onglet actif de la page Congés (dev)
  setMyLeaveTab: (suivant) =>
    set((etat) => ({ myLeaveTab: resolveUpdate(suivant, etat.myLeaveTab) })),
  teamFilterMember: '', // filtre "Demandes de congés" : devId
  setTeamFilterMember: (suivant) =>
    set((etat) => ({ teamFilterMember: resolveUpdate(suivant, etat.teamFilterMember) })),
  teamFilterType: '', // filtre "Demandes de congés" : type
  setTeamFilterType: (suivant) =>
    set((etat) => ({ teamFilterType: resolveUpdate(suivant, etat.teamFilterType) })),
  teamHistoryFilter: {
    // filtres onglet "Historique"
    who: '',
    motif: '',
    statut: '',
    from: '',
    to: '',
  },
  setTeamHistoryFilter: (suivant) =>
    set((etat) => ({ teamHistoryFilter: resolveUpdate(suivant, etat.teamHistoryFilter) })),
  drawerDevId: null, // devId affiché dans le tiroir "fiche personne", null = fermé
  setDrawerDevId: (suivant) =>
    set((etat) => ({ drawerDevId: resolveUpdate(suivant, etat.drawerDevId) })),
  drawerTab: 'infos', // onglet actif du tiroir fiche
  setDrawerTab: (suivant) => set((etat) => ({ drawerTab: resolveUpdate(suivant, etat.drawerTab) })),
});
